import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./locales/de";
import en from "./locales/en";
import es from "./locales/es";
import fr from "./locales/fr";
import it from "./locales/it";

export type Translation = typeof en;

export const fallbackLanguage = "en-UK";
export const supportedLanguages = [fallbackLanguage, "en-US", "de", "it", "fr", "es"] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

export function isSupportedLanguage(language: string | null | undefined): language is SupportedLanguage {
  return supportedLanguages.includes(language as SupportedLanguage);
}

export function getBrowserLanguage(): SupportedLanguage {
  const browserLanguage = navigator.language.split("-")[0]?.toLowerCase();
  return isSupportedLanguage(browserLanguage) ? browserLanguage : fallbackLanguage;
}

export async function setAppLanguage(language: string) {
  const nextLanguage = isSupportedLanguage(language) ? language : fallbackLanguage;

  if (i18n.language !== nextLanguage) {
    await i18n.changeLanguage(nextLanguage);
  }
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    "en-US": { translation: en },
    de: { translation: de },
    it: { translation: it },
    fr: { translation: fr },
    es: { translation: es },
  },
  lng: getBrowserLanguage(),
  fallbackLng: fallbackLanguage,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
